import type { ReactNode } from 'react';
import { useContext } from 'react';

import type { ErrorTracking } from '@sorare/wallet-shared';
import { MessagingContext } from '@sorare/wallet-shared';

import { ErrorFallback } from './ErrorFallback.tsx';
import { ErrorBoundary } from './index.tsx';

export const ErrorFeedback = ({ children }: { children: ReactNode }) => {
  const { sendRequest } = useContext(MessagingContext)!;

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={error => {
        sendRequest<ErrorTracking>('errorTracking', error);
      }}
    >
      {children}
    </ErrorBoundary>
  );
};
